/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-14 14:24:07
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-03-23 10:04:16
 * @name: 工单管理-补发配件安排
 * @Description: 工单管理-补发配件安排
 * @FilePath: \project\src\module\issue\validator\replacementParts.js
 * @Author: desktop
 */
export const validator = [
  {
    key: 'user_id',
    description: '指定发件人id',
    required: true,
    required_message: '请选择指定发件人',
    require_toast: true,
    match: (e) => {
      if (!e) {
        return '请选择指定发件人';
      } else {
        return '';
      }
    },
    match_toast: true,
  },
  {
    key: 'remark',
    description: '备注',
    required: false,
    match: (e) => {
      return '';
    }
  },
  {
    key: 'issue_id',
    description: '工单id',
    required: true,
    required_message: '工单id为必传项',
    match: (e) => {
      return '';
    }
  },
  {
    key: 'run_process_id',
    description: '流程id',
    required: true,
    required_message: '流程id为必传项',
    match: (e) => {
      return '';
    }
  },
]